export default {
  LIQUID_ASSETS_HEADER:
    "What is the total amount of liquid (investable) assets you have?",
  RADIO_ITEMS: [
    {
      label: "< $25,000",
      value: {
        min: 0,
        max: 25000,
      },
    },
    {
      label: "$25,000 - $99,999",
      value: {
        min: 25000,
        max: 99999,
      },
    },
    {
      label: "$100,000 - $499,999",
      value: {
        min: 100000,
        max: 499999,
      },
    },
    {
      label: "$500,000 - $1,000,000",
      value: {
        min: 500000,
        max: 1000000,
      },
    },
    {
      label: "> $1,000,000",
      value: {
        min: 1000000,
        max: 1000000,
      },
    },
  ],
  LIQUID_ASSETS_BUTTON_HEADING: "Continue",
  SUBMIT_ERROR: "Enter a Valid Amount",
};
